import type {AssetGalleryAsset} from '@netx/core-asset-gallery/types';
import {type IAsset} from '@netx/core-asset-next/schema';
import {assetExpires} from '../utils/assetExpires';

import {canModifyAssetExpiration} from './canModifyAssetExpiration';

export const canUnexpireAsset = (asset: AssetGalleryAsset | IAsset) =>
	assetExpires(asset) && canModifyAssetExpiration(asset);
